// Furillo Scroll Menu Plugin
// The semi-colon before the function invocation is a safety
// net against concatenated scripts and/or other plugins
// that are not closed properly.
; (function ($, window, document, undefined) {

    // undefined is used here as the undefined global
    // variable in ECMAScript 3 and is mutable (i.e. it can
    // be changed by someone else). undefined isn't really
    // being passed in so we can ensure that its value is
    // truly undefined. In ES5, undefined can no longer be
    // modified.

    // window and document are passed through as local
    // variables rather than as globals, because this (slightly)
    // quickens the resolution process and can be more
    // efficiently minified (especially when both are
    // regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = 'scrollmenu';
    var defaults = {
        wrapperSelector: 'header.site-header',
        scrollTimerDelay: 50,
        resizeTimerDelay: 100
    };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend({}, defaults, options);

        this.settings = {
            initialPosition: NaN,
            activateFromPosition: NaN,
            previousPosition: 0,
            windowWidth: NaN,
            scrollTimer: null,
            resizeTimer: null
        };

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Plugin.prototype.init = function () {
        var $base = this;

        var $wrapper = $base.$element.parents($base.options.wrapperSelector);
        var wrapperHeight = $wrapper.outerHeight();

        // The initial (non-scoll) position of the menu
        if (isNaN($base.settings.initialPosition)) {
            $base.settings.initialPosition = $base.$element.position().top;

            // IE fix where 0 sometimes is negative decimal
            if ($base.settings.initialPosition < 0)
                $base.settings.initialPosition = 0;
        }

        // Set the position where the scroll menu should activate from
        if (isNaN($base.settings.activateFromPosition)) {
            $base.settings.activateFromPosition = wrapperHeight;
        }

        // Store the current window width for later checking of resize (since some browsers trigger the resize-event when scrolling)
        if (isNaN($base.settings.windowWidth)) {
            $base.settings.windowWidth = $(window).width();
        }

        // Set the height of the wrapper since we are adding and removing the menu. This prevents "jumping" of page.
        $wrapper.css('height', wrapperHeight + 'px');
    };

    Plugin.prototype.scrolling = function () {
        var $base = this;

        var currentPosition = $(window).scrollTop();

        clearTimeout($base.settings.scrollTimer);
        $base.settings.scrollTimer = setTimeout(function () {

            if (currentPosition > $base.settings.activateFromPosition + 20) {

                if (!$base.$element.hasClass('scrollmenu')) {
                    $base.$element.addClass('scrollmenu');
                } else {
                    $base.$element.addClass('scrolling');

                    if (currentPosition < $base.settings.previousPosition) {
                        $base.$element.removeClass('ishidden');
                    } else {
                        $base.$element.addClass('ishidden');
                    }
                }

            } else {
                $base.$element.removeClass('scrollmenu');
                $base.$element.removeClass('scrolling');
                $base.$element.removeClass('ishidden');
            }

            $base.settings.previousPosition = currentPosition;

        }, $base.options.scrollTimerDelay);
    };

    Plugin.prototype.resize = function () {
        var $base = this;

        clearTimeout($base.settings.resizeTimer);
        $base.settings.resizeTimer = setTimeout(function () {
            if ($(window).width() !== $base.settings.windowWidth) {

                // Reset everything and re-init
                $base.settings.initialPosition = NaN;
                $base.settings.activateFromPosition = NaN;
                $base.settings.previousPosition = 0;
                $base.settings.windowWidth = NaN;

                $base.$element.removeClass('scrollmenu');
                $base.$element.removeClass('scrolling');
                $base.$element.removeClass('ishidden');

                $base.init();
            }
        }, $base.options.resizeTimerDelay);
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);